export const TOKEN_KEY = "accessToken";
export const EMAIL_FOR_VERIFY_KEY = "email_token";
export const IS_FORGOT_EMAIL_KEY = "forgot_email";

export const LOGIN_LINK = "/login";
